import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  mutationEditorAggregatedAnswers,
  mutationEditorClear,
} from 'gql/mutations/editor';
import { useQueryLocalEditor } from 'gql/queries/local';
import { useQueryResultsAggregatedByQuestion } from 'gql/queries/results';
import { getQuestionAggregate, getQuestionInfo } from 'questions';

import AggregatedAnswers from './AggregatedAnswers';

const AggregatedAnswersContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const {
    data: {
      editor: { status: editorStatus, questionEditing },
    },
  } = useQueryLocalEditor();
  const isVisible = editorStatus === 'aggregated-answers';
  const { data } = useQueryResultsAggregatedByQuestion({
    variables: {
      questionId: questionEditing?.id,
    },
    skip: !isVisible,
  });
  const allQuestions = useMemo(
    () =>
      [].concat(
        ...course.chapters.map((chapter) => chapter.questions),
        course.questions,
      ),
    [course],
  );
  const previousQuestion = useMemo(
    () =>
      allQuestions.find(
        (question, index) =>
          allQuestions[index + 1]?.id === questionEditing?.id,
      ),
    [allQuestions, questionEditing],
  );
  const nextQuestion = useMemo(
    () =>
      allQuestions.find(
        (question, index) =>
          allQuestions[index - 1]?.id === questionEditing?.id,
      ),
    [allQuestions, questionEditing],
  );
  const aggregatedStudyAnswers = data?.resultsAggregatedByQuestion;
  const aggregateComponent = getQuestionAggregate(questionEditing?.type);
  const questionInfo = getQuestionInfo(questionEditing?.type);
  return (
    <AggregatedAnswers
      aggregatedStudyAnswers={aggregatedStudyAnswers}
      course={course}
      handleQuestionChange={mutationEditorAggregatedAnswers}
      handleClose={mutationEditorClear}
      isVisible={isVisible}
      nextQuestion={nextQuestion}
      previousQuestion={previousQuestion}
      question={questionEditing}
      questionInfo={questionInfo}
      aggregateComponent={aggregateComponent}
      t={t}
      {...props}
    />
  );
};

AggregatedAnswersContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default AggregatedAnswersContainer;
